export default __webpack_public_path__ + "static/media/ankush.05bb5dee.jpg";